// extracted by mini-css-extract-plugin
export default {"reportBody":"ReportTableBody_reportBody__Sq+qN","reportBodyItem":"ReportTableBody_reportBodyItem__JMJcD"};